import {
    createBaseThemeOptions,
    createUnifiedTheme,
    palettes,
  } from '@backstage/theme';
  
  export const myTheme = createUnifiedTheme({
    ...createBaseThemeOptions({
      palette: {
        ...palettes.dark
      }
    }),
    fontFamily: 'Arial, sans-serif',
    defaultPageTheme: 'home',
    components: {
      BackstageHeader: {
        styleOverrides: {
          header: ({ theme }) => ({
            width: 'auto',
            boxShadow: 'none',
            borderBottom: `1px solid ${theme.palette.primary.main}`,
            backgroundColor: "#00aeef70",
            backgroundImage: 'none'
          }),
        },
      },
      BackstageSidebar: {
        styleOverrides: {
          // drawerOpen: {
          //   backgroundColor: '#1c1c1c', // Change this to your desired sidebar color
          // },
          drawer: {
            backgroundColor: '#1c1c1c', // This styles the drawer part of the sidebar
          },
        },
      }
    }
  });